import dagre from '@dagrejs/dagre';
import type { Edge, Node } from '@xyflow/react';

export type LayoutDirection = 'TB' | 'BT' | 'LR' | 'RL';

interface AutoLayoutOptions {
  direction?: LayoutDirection;
  nodeWidth?: number;
  nodeHeight?: number;
  rankSep?: number;
  nodeSep?: number;
}

/**
 * Aplica auto-layout hierárquico via dagre. Devolve novos nodes com `position`
 * recalculada. Edges são preservadas como vieram.
 */
export function applyAutoLayout(
  nodes: Node[],
  edges: Edge[],
  { direction = 'LR', nodeWidth, nodeHeight, rankSep = 80, nodeSep = 40 }: AutoLayoutOptions = {},
): { nodes: Node[]; edges: Edge[] } {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: direction, ranksep: rankSep, nodesep: nodeSep });

  nodes.forEach((node) => {
    const w = nodeWidth ?? (typeof node.width === 'number' ? node.width : 180);
    const h = nodeHeight ?? (typeof node.height === 'number' ? node.height : 80);
    g.setNode(node.id, { width: w, height: h });
  });

  edges.forEach((edge) => {
    g.setEdge(edge.source, edge.target);
  });

  dagre.layout(g);

  const newNodes = nodes.map((node) => {
    const g_node = g.node(node.id);
    const w = typeof node.width === 'number' ? node.width : 180;
    const h = typeof node.height === 'number' ? node.height : 80;
    return {
      ...node,
      position: {
        x: g_node.x - w / 2,
        y: g_node.y - h / 2,
      },
    };
  });

  return { nodes: newNodes, edges };
}
